/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LiveBiddingLogDto } from '../../models/live-bidding-log-dto';

export interface GetLiveBiddingLog$Params {
  lotId: number;
  'X-API-Version'?: string;
}

export function getLiveBiddingLog(http: HttpClient, rootUrl: string, params: GetLiveBiddingLog$Params, context?: HttpContext): Observable<StrictHttpResponse<LiveBiddingLogDto>> {
  const rb = new RequestBuilder(rootUrl, getLiveBiddingLog.PATH, 'get');
  if (params) {
    rb.path('lotId', params.lotId, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LiveBiddingLogDto>;
    })
  );
}

getLiveBiddingLog.PATH = '/api/live-bidding-log/{lotId}';
